module.exports = __webpack_public_path__ + "img/default-question-age-group-img.8b6f4fb3.svg";